import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between py-2 px-3" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm text-surface-800" }, "username", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-h text-surface-500 text-lg cursor-pointer" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-full aspect-square bg-surface-100 dark:bg-surface-800" }, null, -1)
const _hoisted_6 = { class: "p-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center text-2xl pb-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-heart mr-4 cursor-pointer" }),
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-comment mr-4 cursor-pointer" }),
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-send mr-4 cursor-pointer" }),
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bookmark ml-auto cursor-pointer" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-sm pb-1" }, "1,235 likes", -1)
const _hoisted_9 = { class: "text-sm leading-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-1" }, "username", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-surface-500 dark:text-surface-400 pt-1 cursor-pointer" }, " View all 123 comments ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-[10px] text-surface-400 uppercase pt-2" }, "2 HOURS AGO", -1)

import Card from "primevue/card";
import Avatar from "primevue/avatar";


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneratedPost',
  props: {
  content: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { pt: {
      root: {
        class:
          'max-w-[470px] w-full mx-auto bg-surface-0 dark:bg-surface-900 border border-surface-300 dark:border-surface-700 rounded-lg font-sans overflow-hidden',
      },
      body: { class: 'p-0' },
      content: { class: 'p-0' },
      header: { class: 'p-0 bg-transparent' },
    } }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Avatar), {
            icon: "pi pi-user",
            class: "mr-3 bg-surface-200 dark:bg-surface-700",
            size: "normal",
            shape: "circle"
          }),
          _hoisted_3
        ]),
        _hoisted_4
      ])
    ]),
    content: _withCtx(() => [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString(props.content), 1)
        ]),
        _hoisted_11,
        _hoisted_12
      ])
    ]),
    _: 1
  }))
}
}

})